const StationsIndexPage = () => {
  return (
    <div className="StationsIndexPage">
      <h2>Stations:</h2>
      <ul>
        <li>
          <a href="/cases">Accessioning</a>
        </li>
        <li>
          <a href="/station/grossing">Grossing</a>
        </li>
        <li>
          <a href="/station/embedding">Embedding</a>
        </li>
        <li>
          <a href="/station/cutting">Cutting</a>
        </li>
        <li>
          <a href="/station/scanning">Scanning</a>
        </li>
      </ul>
    </div>
  );
};

export default StationsIndexPage;
